(function () {
  try {
    var root = document.querySelector('[data-section-type="product"]');
    if (!root) return;

    function formatMoneyInRs(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, 'Rs. {{amount}}').replace('INR','Rs.');
      }
      var rupees = (cents / 100).toFixed(2);
      var parts = rupees.split('.');
      var intPart = parts[0]; var decPart = parts[1];
      var lastThree = intPart.substring(intPart.length - 3);
      var otherNumbers = intPart.substring(0, intPart.length - 3);
      if (otherNumbers !== '') lastThree = ',' + lastThree;
      var formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g,",") + lastThree;
      return 'Rs. ' + formattedInt + '.' + decPart;
    }

    var bundleRoot = root.querySelector('[data-bundle-offer]');
    if (bundleRoot) {
      var checkboxes = Array.prototype.slice.call(bundleRoot.querySelectorAll('[data-bundle-checkbox]'));
      var requiredCount = parseInt(bundleRoot.dataset.requiredCount,10)||checkboxes.length;
      var discountPercent = parseFloat(bundleRoot.dataset.discountPercent)||0;
      var countLabelEl=bundleRoot.querySelector('[data-bundle-count-label]');
      var comparePriceEl=bundleRoot.querySelector('[data-bundle-compare-price]');
      var totalPriceEl=bundleRoot.querySelector('[data-bundle-total-price]');
      var ctaLabelEl=bundleRoot.querySelector('[data-bundle-cta-label]');
      var ctaButtonEl=bundleRoot.querySelector('[data-bundle-add-to-cart]');
      var bannerEl=bundleRoot.querySelector('[data-bundle-banner]');
      var bannerTextEl=bundleRoot.querySelector('[data-bundle-banner-text]');
      var savePillEl=bundleRoot.querySelector('[data-bundle-save-pill]');
      var saveTextEl=bundleRoot.querySelector('[data-bundle-save-text]');

      function getChecked(){ return checkboxes.filter(function(cb){return cb.checked;}); }
      function recalcBundle(){
        var checked=getChecked(); var fullTotal=0;
        checkboxes.forEach(function(cb){
          var itemLabel=cb.closest('[data-bundle-item]');
          if(cb.checked){itemLabel.classList.remove('is-unselected');fullTotal+=parseInt(itemLabel.dataset.price,10)||0;}
          else itemLabel.classList.add('is-unselected');
        });
        var qualifies=checked.length>=requiredCount;
        var discountedTotal=qualifies?Math.round(fullTotal*(100-discountPercent)/100):fullTotal;
        var savings=fullTotal-discountedTotal;
        if(countLabelEl) countLabelEl.textContent='Total ('+checked.length+' item'+(checked.length===1?'':'s')+')';
        if(qualifies){
          if(comparePriceEl){comparePriceEl.style.display='';comparePriceEl.textContent=formatMoneyInRs(fullTotal);}
          if(totalPriceEl) totalPriceEl.textContent=formatMoneyInRs(discountedTotal);
          if(bannerEl) bannerEl.style.display='none';
          if(savePillEl&&saveTextEl){saveTextEl.textContent='You save '+formatMoneyInRs(savings);savePillEl.style.display='';}
        } else {
          if(comparePriceEl) comparePriceEl.style.display='none';
          if(totalPriceEl) totalPriceEl.textContent=formatMoneyInRs(fullTotal);
          if(savePillEl) savePillEl.style.display='none';
          var remaining=requiredCount-checked.length;
          if(remaining>0&&bannerEl&&bannerTextEl){bannerTextEl.textContent='Add '+remaining+' more item'+(remaining===1?'':'s')+' to get '+discountPercent+'% OFF on your order!';bannerEl.style.display='';}
          else if(bannerEl) bannerEl.style.display='none';
        }
        if(ctaLabelEl) ctaLabelEl.textContent='Add '+checked.length+' to Cart';
        if(ctaButtonEl) ctaButtonEl.disabled=checked.length===0;
      }
      checkboxes.forEach(function(cb){cb.addEventListener('change',recalcBundle);});
      if(ctaButtonEl){
        ctaButtonEl.addEventListener('click',function(){
          var checked=getChecked(); if(!checked.length) return;
          var items=checked.map(function(cb){return{id:cb.value,quantity:1};});
          ctaButtonEl.disabled=true;
          var originalLabel=ctaLabelEl?ctaLabelEl.textContent:'';
          if(ctaLabelEl) ctaLabelEl.textContent='Adding…';
          var payload={items:items};
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)})
            .then(function(res){if(!res.ok)throw new Error('add failed');return res.json();})
            .then(function(data){if(ctaLabelEl)ctaLabelEl.textContent='Added!';setTimeout(function(){if(ctaLabelEl)ctaLabelEl.textContent=originalLabel;ctaButtonEl.disabled=false;},1500); if(window.openAndRefreshCart) window.openAndRefreshCart(data.sections);})
            .catch(function(){if(ctaLabelEl)ctaLabelEl.textContent=originalLabel;ctaButtonEl.disabled=false;window.location.href='/cart';});
        });
      }
      recalcBundle();
    }
  } catch(err){ console.error('mp-bundle script error:',err); }
})();